module.exports = __webpack_public_path__ + "static/plaintext-5b0cae1ec7bf27bdcd3b327aede77c2d.png";